import { twMerge } from "tailwind-merge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/pro-solid-svg-icons";

const ArrowButton = ({ ref, back = false, className, variant }) => {
  if (variant === "gallery") {
    return (
      <span
        className={twMerge(
          "h-[2.25rem] w-[2.25rem] rounded-full bg-[#B48C8C] text-white flex justify-center items-center transition-colors duration-200 hover:bg-[#9c7878]",
          className
        )}
      >
        <FontAwesomeIcon
          icon={back ? faArrowLeft : faArrowRight}
          className="w-5 h-5"
        />
      </span>
    );
  }

  return (
    <span
      className={twMerge(
        "h-[1.875rem] w-[1.875rem] ml-2 rounded-full bg-primary text-primary-text",
        "relative group/arrow flex justify-center items-center overflow-hidden",
        className
      )}
      ref={ref}
    >
      <FontAwesomeIcon
        icon={back ? faArrowLeft : faArrowRight}
        className={twMerge(
          "h-4 w-auto text-base text-primary-text",
          "group-hover/arrow:transition-all group-hover/arrow:duration-300",
          back ? "group-hover/arrow:translate-x-[-175%]" : "group-hover/arrow:translate-x-[175%]",
        )}
      />
      <FontAwesomeIcon
        icon={back ? faArrowLeft : faArrowRight}
        className={twMerge(
          "absolute h-4 w-auto text-base text-primary-text",
          back ? "translate-x-[175%]" : "translate-x-[-175%]",
          "group-hover/arrow:transition-all group-hover/arrow:duration-300",
          "group-hover/arrow:translate-x-0 group-hover/arrow:delay-100",
        )}
      />
    </span>
  );
};

export default ArrowButton;
